export { default } from './PopupMobileWarning';


// WEBPACK FOOTER //
// ./src/components/shared/PopupMobileWarning/index.ts